import { isLocalhost, isWeb } from 'shared/constants/platform';
import { isE2E } from 'shared/helpers/isE2E';

interface CaptchaTokenArgs {
  xVaroCToken?: string;
  isCloudflareTurnstileEnabledForNative?: boolean;
}

const hasCaptchaToken = ({
  xVaroCToken,
  isCloudflareTurnstileEnabledForNative,
}: CaptchaTokenArgs) => {
  if (isE2E || global.isE2E) {
    return true;
  }

  if (!isLocalhost && (isWeb || isCloudflareTurnstileEnabledForNative)) {
    return !!xVaroCToken;
  }

  return true;
};

export default hasCaptchaToken;
